(function () {
  'use strict';

  angular.module('app').component('bookingItemListProductDetail', bookingItemListProductDetail());

  function bookingItemListProductDetail() {
    return {
      bindings: {
        booking: '<',
      },
      controller: function () {},
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bookings/components/' +
        'booking-item-list-product-detail/booking-item-list-product-detail.component.html',
    };
  }
})();
